import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const STARTS_WITH_ACTIVITY_FRAGMENT = gql `
  fragment StartsWithActivityFragment on StartsWithActivity {
    rounds {
      steps {
        answer
        answerAudio {
          audio {
            ...AssetFragment
          }
        }
        activityImage: optionalImage {
          image {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default STARTS_WITH_ACTIVITY_FRAGMENT;
